function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16.000000, -62.000000) translate(16.000000, 62.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "#CCE6D8",
  rx: 8
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  stroke: "#2B9D8B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2B9D8B",
  strokeWidth: 0.5,
  d: "M8 0C5.054 0 2.667 2.328 2.667 5.2 2.667 11.267 0 13 0 13h16s-2.667-1.733-2.667-7.8C13.333 2.328 10.946 0 8 0z",
  transform: "translate(4.000000, 4.000000) translate(4.000000, 4.000000)"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M9.73 15c-.358.617-1.017.996-1.73.996-.713 0-1.372-.38-1.73-.996",
  transform: "translate(4.000000, 4.000000) translate(4.000000, 4.000000)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(4.000000, 4.000000)"
})))));

function SvgNotificationDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDefault);
export default __webpack_public_path__ + "static/media/notification_default.3eddb4a0.svg";
export { ForwardRef as ReactComponent };